module.exports = __webpack_public_path__ + "img/brands-bparking.cd1e4dd5.svg";